import React from "react";
import { CategoryContainer } from "../../components/CategoryContainer";
import {
  CheckboxRHF,
  ConditionalRHFRender,
} from "../../components/RHFWrappedComponents";
import { useFormContext } from "react-hook-form";
import { isEmptyObject } from "../../util";
import { Location } from "../../components/Location";

export function Locations() {
  const { getValues } = useFormContext();
  // If these values are populated on page load, we want the question to render as "Started"
  const emptyCurrentLocation = isEmptyObject(
    getValues("demographics.currentLocation")
  );
  return (
    <>
      <CategoryContainer
        title="Current Location"
        specialHeaderBehavior="initialRenderAsUnstarted"
        unstartedSubtitle="No current location listed."
        unstarted={emptyCurrentLocation}
      >
        <Location
          parentName="demographics.currentLocation"
          countryList={[{ label: "United States", value: "US" }]}
          showAddress={false}
          stateIsRequired={false}
        />
        <CheckboxRHF
          name="demographics.permanentLocation.same_as_current"
          label="This is also my permanent address"
        />
      </CategoryContainer>
      <ConditionalRHFRender
        dependantField="demographics.permanentLocation.same_as_current"
        dependantValue={false}
      >
        <CategoryContainer
          title="Permanent Location"
          specialHeaderBehavior="renderHeaderAccordion"
        >
          <Location
            parentName="demographics.permanentLocation"
            countryList={[{ label: "United States", value: "US" }]}
            showAddress={false}
            stateIsRequired={false}
          />
        </CategoryContainer>
      </ConditionalRHFRender>
    </>
  );
}
